export default "__VITE_ASSET__7ac47d89__"